// extracted by mini-css-extract-plugin
export default {"container":"BookSearch_container__l0B4L","containerBooks":"BookSearch_containerBooks__hZyud","search":"BookSearch_search__2k0YO","containerBook":"BookSearch_containerBook__2j5r8"};